<cdk-virtual-scroll-viewport #viewportGestion id="viewportGestion" item [appendOnly]="false" [tvsItemSize]="24"
[headerHeight]="34" class="wrapper mat-elevation-z2 tableStyle" *ngIf="!isCompania">
<table cdk-table [dataSource]="histVolData" class="table-striped tableStyle table1" >

  <tr cdk-header-row *cdkHeaderRowDef="displayedColumns; sticky: true" class="sticky-header"></tr>
  <tr cdk-row *cdkRowDef="let row; columns: displayedColumns;" (click)="selectRow(row)"
    [ngClass]="{'selected': row === filaSeleccionada}"></tr>
  <ng-container *ngFor="let tablecol of tableColumns">

    <ng-container [cdkColumnDef]="tablecol.id">
      <th cdk-header-cell *cdkHeaderCellDef="" class="sticky-header" [style.width.px]="tablecol.id === 'volume' ? 100 : null">
        {{tablecol.name}}
      </th>
      <td cdk-cell *cdkCellDef="let item" [ngClass]="{'salida': item[tablecol.id] === 'SALIDA',
                                                          'entrada': item[tablecol.id] === 'ENTRADA',
                                                          'numero-positivo': item[tablecol.id] > 0,
                                                          'numero-negativo': item[tablecol.id] < 0
                                                          }"
                                                          [style.width.px]="tablecol.id === 'volume' ? 100 : null"
                                                          class="overflow-cell">
        
        <ng-container *ngIf="tablecol.isString">
          {{item[tablecol.id]}} 
        </ng-container>
        <ng-container *ngIf="tablecol.isDate">
          {{item[tablecol.id] | smartDate }}
        </ng-container>
        <ng-container *ngIf="tablecol.isNumber && tablecol.id!=='volume'">
          {{item[tablecol.id] |number:'1.2-2'}}
        </ng-container>
         <ng-container *ngIf="tablecol.isNumber && tablecol.id==='volume'">
          {{ item[tablecol.id] | numberSuffix }}
        </ng-container>
        

        

      </td>
    </ng-container>
  </ng-container>
</table>
</cdk-virtual-scroll-viewport>
<div class="spinner-container" *ngIf="loadVolatil">
  <mat-spinner diameter="100"></mat-spinner>
</div>
<div class="col-panel-wrapper">
  <div class="floating-col-panel" (mouseleave)="contraerColPanel()"
       [ngClass]="{'expanded': colPanelOpen}">
    <div class="col-panel-toggle" (mouseenter)="expandirColPanel()">
      <mat-icon>{{colPanelOpen ? 'chevron_left' : 'view_column'}}</mat-icon>
    </div>
    <div class="col-panel-content">
      <h6 class="col-panel-title mb-2">Columnas</h6>
      <div class="col-panel-option" *ngFor="let column of tableColumns">
        <mat-checkbox [checked]="column.isShow" (change)="toggleColumnVisibility(column.id)" [color]="'primary'">{{column.name}}</mat-checkbox>
      </div>
    </div>
  </div>
<cdk-virtual-scroll-viewport #viewportCompania id="viewportCompania" item [appendOnly]="false" [tvsItemSize]="24"
[headerHeight]="34" class="wrapper2 mat-elevation-z2 tableStyle" *ngIf="isCompania">
<table cdk-table [dataSource]="histVolCompData" class="table-striped tableStyle table2" >

  <tr cdk-header-row *cdkHeaderRowDef="displayedColumns; sticky: true" class="sticky-header"></tr>
  <tr cdk-row *cdkRowDef="let row; columns: displayedColumns;" (click)="selectRow(row)"
    [ngClass]="{'selected': row === filaSeleccionada}"></tr>
  <ng-container *ngFor="let tablecol of tableColumns">

    <ng-container [cdkColumnDef]="tablecol.id">
      <th cdk-header-cell *cdkHeaderCellDef="" class="sticky-header" [style.width.px]="tablecol.id === 'volume' ? 100 : null">
        {{tablecol.name}}
      </th>
      <td cdk-cell *cdkCellDef="let item" [ngClass]="{'salida': item[tablecol.id] === 'SALIDA',
                                                          'entrada': item[tablecol.id] === 'ENTRADA',
                                                          'numero-positivo': item[tablecol.id] > 0,
                                                          'numero-negativo': item[tablecol.id] < 0
                                                          }"
                                                          [style.width.px]="tablecol.id === 'volume' ? 100 : null"
                                                          class="overflow-cell">
        <ng-container *ngIf="tablecol.isString">
          {{item[tablecol.id]}}
        </ng-container>
        <ng-container *ngIf="tablecol.isDate">
          {{item[tablecol.id] | smartDate }}
        </ng-container>
        <ng-container *ngIf="tablecol.isNumber && tablecol.id!=='volume'">
          {{item[tablecol.id] |number:'1.2-2'}}
        </ng-container>
         <ng-container *ngIf="tablecol.isNumber && tablecol.id==='volume'">
          {{ item[tablecol.id] | numberSuffix }}
        </ng-container>
      </td>
    </ng-container>
  </ng-container>
</table>
</cdk-virtual-scroll-viewport>
</div>
<div class="spinner-container2" *ngIf="loadVolatilCompania">
  <mat-spinner diameter="100"></mat-spinner>
</div>